<template>
  <div class="text-center">
    <v-dialog
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="1000"
      v-model="dialog"
      scrollable
      :persistent="isReloadShown"
    >
      <v-card>
        <v-card-title class="primary white--text">
          Nhập EXCEL
          <v-spacer />
          <v-btn dark icon>
            <v-icon @click="closePopup">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-5 border">
          <div class="wrap">
            <div
              class="d-flex flex-column justify-center align-center mx-auto"
              style="width: 330px; min-height: 320px"
              v-if="step === 'import'"
            >
              <v-img max-width="100px" max-height="100px" contain src="@/assets/upload-file.svg"></v-img>
              <div class="text-center content-text mt-5" @click="exportExcelTemplate">
                Tải tệp Excel (.xlsx) chứa danh sách giáo viên
              </div>
              <div class="mt-5">
                <v-btn color="primary" class="mr-5" @click="exportExcelTemplate" outlined>Tải mẫu nhập</v-btn>
                <v-btn color="primary" class="elevation-0 white--text" :loading="isSelecting" @click="onExcelUpload">
                  <span class="white--text">Chọn tệp</span>
                  <input
                    ref="uploader"
                    type="file"
                    class="d-none"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    @change="onFileChanged"
                  />
                </v-btn>
              </div>
            </div>
            <PopupImportPreview
              :file="selectedFile.name"
              @reset="resetInput"
              v-else-if="step === 'send'"
              :isError="isError"
            />
          </div>
          <div v-if="isReloadShown" class="mt-2">Trang sẽ được tự động tải lại sau {{ countDown }} giây...</div>
        </v-card-text>
        <hr color="#E0E0E0" />
        <v-card-actions>
          <v-btn class="ma-2 text-uppercase" width="100px" outlined :disabled="isReloadShown" @click="closePopup"
            >Hủy</v-btn
          >
          <v-spacer />
          <v-btn
            class="ma-2 text-uppercase white--text"
            width="100px"
            color="primary"
            :disabled="!impItems.length"
            @click="save"
            >Lưu</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PopupImportPreview from './PopupImportPreview.vue'
import readXlsxFile from 'read-excel-file'
import { mapActions, mapMutations, mapState } from 'vuex'

const schema = {
  'Tên giáo viên': {
    prop: 'name',
    type: String,
  },
  'Mã giáo viên (format text)': {
    prop: 'code',
    type: String,
  },
}

export default {
  components: { PopupImportPreview },
  data() {
    return {
      dialog: false,
      progress: 1,
      isSelecting: false,
      selectedFile: null,
      step: 'import',
      colorButtonSave: '#E0E0E0',
      isError: false,
      countDown: 5,
      isReloadShown: false,
    }
  },
  computed: {
    ...mapState('boardingClassTeacher', ['impItems']),
  },
  methods: {
    ...mapActions('boardingClassTeacher', ['updateByExcel']),
    ...mapMutations('boardingClassTeacher', ['setImportedItems']),
    onExcelUpload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      this.$refs.uploader.click()
    },
    exportExcelTemplate() {
      this.$loading.active = true
      this.$utils.exportExcel(
        [{ name: 'gvbm test', code: 'testg' }],
        [
          { text: 'Tên giáo viên', value: 'name' },
          { text: 'Mã giáo viên (format text)', value: 'code' },
        ],
        'LBT_DS_GV'
      )
      this.$loading.active = false
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, { schema })
      } catch (error) {
        this.$alert.error({
          title: 'File không có định dạng.',
          description: 'xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)',
        })
        this.$loading.active = false
        return
      }
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const results = readFileResult.rows
        this.step = 'send'
        this.colorButtonSave = '#0D47A1'
        this.setImportedItems(results)
      }
      this.$loading.active = false
    },
    closePopup() {
      this.dialog = false
      this.resetInput()
    },
    openDialog() {
      this.dialog = true
    },
    async save() {
      if (this.impItems[0] && !this.isError) {
        this.$loading.active = true
        try {
          await this.updateByExcel({ id: this.$route.params.id, codes: this.impItems.map(x => x.code) })
          await this.fetchItems({ _sort: 'nameToNumber:ASC', boardingClasses: this.$route.params.id })
          
          this.$alert.success('Đã tải file lên thành công!')
          this.closePopup()
        } catch (error) {
        } finally {
          this.$loading.active = false
        }
      }
    },
    resetInput() {
      this.step = 'import'
      this.selectedFile = null
      this.colorButtonSave = '#E0E0E0'
      this.setImportedItems([])
      this.isError = false
    },
  },
}
</script>
<style>
.wrap {
  border: 1px solid rgb(222, 222, 222);
  border-radius: 4px;
}
</style>
